<p-table
  [value]="histories"
  [loading]="loading"
  [paginator]="histories.length > 10"
  [rows]="10">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 18rem">Utente</th>
      <th style="width: 12rem">Data</th>
      <th>Modifiche</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-h>
    <tr>
      <td>
        <span class="mb-0">{{ h.created_by?.name }} {{ h.created_by?.last_name }}</span
        ><br />
        <small class="grey-text">{{ h.created_by?.username }}</small>
      </td>
      <td>{{ h.date | date: 'dd MMM yyyy HH:mm:ss' }}</td>
      <td>
        <div *ngFor="let c of h.changes">
          <b>{{ c.label }}:</b>
          <ng-container *ngIf="c.field === 'aggiornati_anche'; else fromTo">
            {{ formatValue(c.to) }}
          </ng-container>
          <ng-template #fromTo>
            {{ formatValue(c.from) }} <i class="pi pi-arrow-right text-xs"></i>
            {{ formatValue(c.to) }}
          </ng-template>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td
        colspan="3"
        class="py-2 text-center">
        Nessuna modifica registrata.
      </td>
    </tr>
  </ng-template>
</p-table>
